import Nullstack from 'nullstack';
export default function IconBinary({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-binary",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 10v-5h-1m8 14v-5h-1"
  }), "   ", Nullstack.element("rect", {
    x: "15",
    y: "5",
    width: "3",
    height: "5",
    rx: ".5"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "14",
    width: "3",
    height: "5",
    rx: ".5"
  }), "   ", Nullstack.element("path", {
    d: "M6 10h.01m-.01 9h.01"
  }), " ");
}